import { useSelector } from "react-redux";
import { getZendeskWidgetTypeSelector } from "../zendeskSelectors";
import getZendeskWidgetInstanceByType from "../utils/getZendeskWidgetInstanceByType";
import { useMemo } from "react";

function useZendeskWebWidgetInstance() {
    const widgetType = useSelector(getZendeskWidgetTypeSelector);

    return useMemo(() => getZendeskWidgetInstanceByType(widgetType), [widgetType]);
}

export default useZendeskWebWidgetInstance;
